export function formatToTwoDecimalPlaces(value) {
  if (value === undefined || value === null || value === "-") {
    return value;
  }
  return parseFloat(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
